import {
  ChangeEvent,
  ContactFormData,
  ContentType,
} from '@bm-js/atlascloud-shared'
import Input from './Input'
import Textarea from './Textarea'
import Select from './Select'
import { marginOptions } from '@bm-js/atlascloud-ui'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'

type Props = {
  content: ContentType<ContactFormData>
  setData: (e: ChangeEvent) => void
}

const ContactFormEditor = ({ content, setData }: Props) => {
  const { tr } = useTr()

  return (
    <>
      <Input
        light
        type='text'
        label={tr(TrKey.contactFormEditorHeaderLabel)}
        desc={tr(TrKey.contactFormEditorHeaderDescription)}
        name='header'
        id='header'
        value={content.data.header}
        onChange={setData}
      />
      <Textarea
        light
        label={tr(TrKey.contactFormEditorInstructionLabel)}
        desc={tr(TrKey.contactFormEditorInstructionDescription)}
        name='instruction'
        id='instruction'
        placeholder={tr(TrKey.contactFormEditorInstructionPlaceholder)}
        value={content.data.instruction}
        onChange={setData}
      />
      <Input
        light
        type='email'
        label={tr(TrKey.contactFormEditorResponseEmailLabel)}
        desc={tr(TrKey.contactFormEditorResponseEmailDescription)}
        name='responseEmail'
        id='responseEmail'
        placeholder={tr(TrKey.contactFormEditorResponseEmailPlaceholder)}
        value={content.data.responseEmail}
        onChange={setData}
      />
      <Select
        light
        label={tr(TrKey.contactFormEditorMarginBottomLabel)}
        desc={tr(TrKey.contactFormEditorMarginBottomDescription)}
        id='marginBottom'
        name='marginBottom'
        value={content.data.marginBottom}
        onChange={setData}
      >
        <option value='' disabled>
          {tr(TrKey.contactFormEditorMarginBottomPlaceholder)}
        </option>
        {marginOptions.map((opt) => (
          <option key={`margin_option_${opt.value}`} value={opt.value}>
            {opt.name}
          </option>
        ))}
      </Select>
    </>
  )
}

export default ContactFormEditor
